<template>
<div>
  <p class="text-h5">Measuring district population deviation from average district size</p>
  <p>
    On April 26, 2021 the U.S. Census Bureau published the first results from the 2020 Census: the nationwide population, each state's population, and the number of congressional seats apportioned to each state.
    </p>
    <p>
    The Census Bureau has not yet published population data from the 2020 Census for areas smaller than states, such as congressional or state legislative districts. <strong>Therefore, the <em><span style="color: var(--prussian-blue);">Redistricting</span> &amp; <span style="color: var(--imperial-red);">You</span></em> map compares each district's latest 2019 population estimate to its state's average district population also based on the 2019 estimates, rather than the 2020 state population counts.</strong>
    </p>
    <p>
    This change means the district deviation patterns on the map are slightly different from how they looked immediately after the Census Bureau's April 26 announcement (in many states the 2020 count is different from the 2019 estimates, so the earlier patterns may not have reflected 100% of the state's 2020 population). <strong>Because the deviation patterns are based on 2019 estimates, they reflect the <em>potential</em> that each district is "over" or "under" populated compared to each state's ideal district size.</strong> The patterns may change once the Census Bureau publishes small-area data from the 2020 Census later in 2021.</p>
</div>
</template>
<script>

export default {
  name: "ModalDataNote",
  components: {
    // ModalTabOpeners
  },
  data: function () {
    return {};
  },
  methods:{}
};
</script>
<style scoped>
</style>